import { ReactElement } from 'react'
import { TooltipProps } from 'recharts'
import { useTranslate } from 'utils'

type CustomChartTooltipProps = TooltipProps<number, string> & { currencySymbol?: string}

export const CustomChartTooltip = ({ active, payload, label, currencySymbol}: CustomChartTooltipProps): ReactElement => {
    const { __ } = useTranslate()

    if (active && payload?.length) {
        return (
            <div style={{
                background: 'rgba(255, 255, 255, 0.9)',
                color: '#374151',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                backdropFilter: 'blur(4px)',
                border: '1px solid #e5e7eb',
                borderRadius: '0.75rem',
                padding: '0 1rem 0.75rem',
                fontSize: '0.875rem',
            }}>
                <p style={{ fontSize: '1rem' }}>{`${label}`}</p>
                <div>
                    {
                        payload?.map((payloadData, index) => (
                            <div key={index} style={{ marginBottom: 8 }}>
                                <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 8, backgroundColor:  payloadData.color}}></span>
                                <span>&nbsp;</span>
                                <span>{__(payloadData?.name as string)}</span>
                                <span>:&nbsp;</span>
                                <span style={{ fontWeight: 600 }}>{`${payloadData?.name === 'sales' && currencySymbol ? currencySymbol + ' ' : ''}`}{payloadData?.value}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    return <></>
}
